export default __webpack_public_path__ + "static/blob-05-98f9fb73260866970144be44bd785f16.svg";